module.exports = __webpack_public_path__ + "static/media/nodeMiddleware.357875be.png";